import uuid from 'uuid/v4';

import { isBlank } from 'lib/string';

import { authHeaders, betterFetch, CCS_URL } from './helper';

/**
 * gets folder data from redis
 * @param {string} folderID - the id of the folder
 * @param {string} contentType - expected contentType folder/page or null for both
 * @returns {Promise<Response>} the reponse object
 */
export const getFolder = function getFolder(folderID, contentType) {
  const headers = authHeaders();
  const url = `${CCS_URL}/folder/${folderID}${
    contentType ? `?contentType=${contentType}` : ''
  }`;
  return betterFetch(url, { headers });
};

/**
 * adds a folder to the canvas backend
 * @param {string} folderName - the name of the folder to be added
 * @param {string} cwd - the id of the current working directory
 * @returns {Promise<Response>} the reponse object
 */
export const addFolder = function addFolder(folderName, cwd) {
  if (isBlank(folderName)) {
    return Promise.reject(new Error('folder name cannot be blank'));
  }

  const headers = authHeaders();
  const payload = {
    Id: uuid(),
    Name: folderName,
    ParentFolderId: cwd
  };
  const options = {
    method: 'POST',
    headers,
    body: JSON.stringify(payload)
  };
  return betterFetch(`${CCS_URL}/folder`, options);
};

/**
 * deletes folder data from dynamo
 * @param {string} folderID - the id of the folder
 * @returns {Promise<Response>} the reponse object
 */
export const deleteFolder = function deleteFolder(folderID) {
  const headers = authHeaders();
  const options = {
    method: 'DELETE',
    headers
  };
  const url = `${CCS_URL}/folder/${folderID}`;
  return betterFetch(url, options);
};

/**
 * updates folder name in dynamo
 * @param {string} folderName - the name of the folder
 * @param {string} folderID - the id of the folder
 * @returns {Promise<Response>} the reponse object
 */
export const updateFolder = function updateFolder(folderName, folderID) {
  const headers = authHeaders();
  const payload = {
    Id: folderID,
    Name: folderName
  };
  const options = {
    method: 'PUT',
    headers,
    body: JSON.stringify(payload)
  };
  const url = `${CCS_URL}/folder`;
  return betterFetch(url, options);
};

/**
 * moves a folder to a different folder
 * @param {string} folderId - folder id (to be moved)
 * @param {string} targetFolderId - target folder id
 * @returns {Promise<Response>} the response object
 */
export const moveFolder = function moveFolder(folderId, targetFolderId) {
  const headers = authHeaders();
  const options = {
    method: 'PUT',
    headers
  };
  const queryParams = new URLSearchParams({
    newParentFolderId: targetFolderId
  });
  const url = `${CCS_URL}/folder/move/${folderId}?${queryParams}`;

  return betterFetch(url, options);
};
